/**
 * Detect if Web Share API is available. This has 90% support overall and 95%+
 * on mobile browsers, and is easier and better than building our own.
 * See: https://caniuse.com/web-share
 */
export function isShareSupported() {
  return "canShare" in navigator;
}
